import { render, staticRenderFns } from "./TabProductsReservation.vue?vue&type=template&id=3c05dac8&"
import script from "./TabProductsReservation.vue?vue&type=script&lang=ts&"
export * from "./TabProductsReservation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports